enum TestStatus {
  COMPLETED = 'completed',
  IN_PROGRESS = 'in_progress',
  DOCTOR_REPORT_PENDING = 'doctor_report_pending',
  PHARMACY_REPORT_PENDING = 'pharmacy_report_pending',
}

export { TestStatus };